<template>
    <p>Admin Panel Web Health {{ status }}</p>
</template>

<script>
import customerOps from '../api/users'
export default {
    data: () => ({
       status:null 
    }),
    created() {
        customerOps.health({}).then(response => {
          console.log(`[Health] - Database health success.`,response);
          this.status = response;
        })
        .catch(err => {
          console.error(`[Health] - Database health Failure.`);
          this.status = err;
        });
    }
}
</script>